import { IComponentOptions, IController } from 'angular';
import './public.component.scss';
import { AuthService } from '../../core/services/auth/auth.service';

class PublicController implements IController {
  static $inject = [ 'AuthService' ];

  constructor( private authService: AuthService ) {

  }

  get isAuth() {
    return this.authService.isLoggedIn();
  }
}

export const PublicComponent: IComponentOptions = {
  controller: PublicController,
  template: require('./public.component.html')
};



// WEBPACK FOOTER //
// ./app/states/public/public.component.ts